const ProjectData=[
    {
        count:"0",
        img:"/images/mainpage.png",
        projectHeading:"E-Commerce Web App",
        Year:"2024",
        SoftUsed1:"Mern Stack",
        ProjDespriction:"Built an Amazon clone with the MERN stack, Redux for state management, and Bootstrap for responsive design. Features include user login, product listings, order management.Developed an admin dashboard for managing products, orders, users, and reviews, with capabilities to update order statuses and user roles",
        SoftUsed2:"Redux",
        link:"https://github.com/DhushyanthRavichandran/Amazon",
    },
    {
        count:"1",
        img:"/images/neuropulse.png",
        projectHeading:"NeuroPulse-AI based Stroke identifier",
        Year:"2024",
        SoftUsed1:"MachineLearning",
        ProjDespriction:"NeuroPulse is a website that predicts strokes using a machine learning Random Forest algorithm and provides information about stroke, including causes and prevention.",
        SoftUsed2:"Flask",
        link:"https://github.com/DhushyanthRavichandran/NeuroPulse",
    },
    {   
        count:"0",
        img:"/images/smarklock.jpg",
        projectHeading:"Smark Door Lock",
        Year:"2024",
        SoftUsed1:"Arduino IDE",
        ProjDespriction:"smart door lock system with a fingerprint sensor and solenoid lock. If the fingerprint matches, the door unlocks and the user is notified. If it doesn't, the owner receives an alert call. This was developed for Aarthia Impex.",
        SoftUsed2:"Arduino UNO",
        link:"https://github.com/DhushyanthRavichandran/consultancy-Project",
    },
    {
        count:"1",
        img:"/images/portfolio.png",
        projectHeading:"Personal Portfolio",
        Year:"2024",
        SoftUsed1:"React",
        ProjDespriction:"I'm excited to share my personal portfolio, crafted with care using ReactJS. This site showcases my journey, skills, and projects, providing a smooth and interactive experience with modern web technologies",
        SoftUsed2:"Vercel",
        link:"https://github.com/DhushyanthRavichandran/Portfolio-ReactJS",
    },
    {
        count:"0",
        img:"/images/wineclassifier.png",
        projectHeading:"Wine Classifier ",
        Year:"2023",
        SoftUsed1:"MachineLearning",
        ProjDespriction:"It is a website of a machine learning model trained with the XGBoost algorithm to classify wines as either red or white wine",
        SoftUsed2:"Streamlit",
        link:"https://github.com/DhushyanthRavichandran/Wine-Prediction",
    }

    
];
export default ProjectData;
